import { getDetailsTabRouteObjects } from '../../../utility/route';
import Royalty from '../royalty';
import AccountsList from '../components/accounts/accounts-list';
import ContractsList from '../components/contracts/contracts-list';
import StatementList from '../components/statements/statement-list';
import DefaultStatementList from '../components/statements/statement-list';
// import Payments from '../components/statements/payments';
import CheckList from '../components/statements/checklist'
import Recoupable from '../components/recoupables/recoupable'
import RoyaltyPlugin from '../components/plugin/plugin';

import {
    royaltyAccountsListLDTRoutes,
    royaltyContractsListLDTRoutes,
    statementsListLDTRoutes,
} from './routes';

export default [{
    path: "/main/royalty",
    name: "royalty",
    component: Royalty,
    redirect: "main/royalty/accounts",
    children: [
        ...getDetailsTabRouteObjects(royaltyAccountsListLDTRoutes, AccountsList),
        ...getDetailsTabRouteObjects(royaltyContractsListLDTRoutes, ContractsList),
        ...getDetailsTabRouteObjects(statementsListLDTRoutes, DefaultStatementList),
        {
            name: 'Checklist',
            path: "checklist",
            component: CheckList
        },
        {
            name: 'Recoupable',
            path: "recoupable",
            component: Recoupable
        },
        {
            name: 'royalty_plugins',
            path: "plugins",
            component: RoyaltyPlugin
        },
        // {
        //     name: 'catalog_statement',
        //     path: 'statements',
        //     redirect: 'statements/overview',
        //     component: Statement,
        //     children: [
        //       {
        //         name: 'statement_overview',
        //         path: 'overview',
        //         component: StatementOverview
        //       },
        //       {
        //         name: 'statement_payment',
        //         path: 'payments',
        //         component: Payments
        //       }
        //     ]
        //   },


    ],
},


];